import { render } from "./TeamUserPermission.vue?vue&type=template&id=a3f112ac"
import script from "./TeamUserPermission.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamUserPermission.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Settings/TeamUserPermission.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a3f112ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a3f112ac', __exports__)) {
    api.reload('a3f112ac', __exports__)
  }
  
  module.hot.accept("./TeamUserPermission.vue?vue&type=template&id=a3f112ac", () => {
    api.rerender('a3f112ac', render)
  })

}


export default __exports__